export class IntersectionObserver {
  items = [];

  constructor(opts) {
    this.io = new window.IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.items.filter(withTarget(entry.target)).forEach((item) => {
          item.callback(entry);
        });
      });
    }, opts);
  }

  observe(target, callback) {
    this.items.push({
      target: target,
      callback: callback,
    });
    this.io.observe(target);
  }

  unobserve(target, callback) {
    const itemsToRemove = this.items.filter(
      (item) =>
        item.target === target &&
        (callback == undefined ? item.callback === callback : true)
    );
    itemsToRemove.forEach((item) => {
      this.io.unobserve(item.target);
    });
    this.items = this.items.filter((item) => itemsToRemove.includes(item));
  }

  destroy() {
    this.items.forEach((item) => this.io.unobserve(item.target));
    delete this.items;
    delete this.io;
  }
}

function withTarget(target) {
  return (item) => {
    return item.target === target;
  };
}

// ----------------------------------------------------------------------------

const ATTR_SETTERS = {
  children: function (elt, children) {
    children.forEach((child) => elt.appendChild(child));
  },
  text: function (elt, value) {
    elt.appendChild(document.createTextNode(value));
  },
  html: function (elt, value) {
    elt.innerHTML = value;
  },
  className: function (elt, value) {
    const cls = Array.isArray(value) ? value : [value];
    elt.className = cls.join(" ");
  },
  style: setStyle,
  _default: function (elt, value, name) {
    elt.setAttribute(name, value);
  },
};

export function createElement(tagName, attrs) {
  const elt = window.document.createElement(tagName);
  updateAttributes(elt, attrs);
  return elt;
}

export function updateAttributes(elt, attrs) {
  for (var name in attrs) {
    const setter = ATTR_SETTERS[name] || ATTR_SETTERS._default;
    setter(elt, attrs[name], name);
  }
  return elt;
}

export function setStyle(elt, props) {
  for (var name in props) {
    elt.style[name] = props[name];
  }
  return elt;
}
